import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { GET_MEDIA_URL } from "../../config/webService";
import {
  currentLanguage,
  formatAmount,
  getFormatedDate,
  convertToSentenceCase
} from "../../util/common";
import { useAppNavigation } from "../../hooks";
import { Button, RiyalIcon, Icon, NotificationHelper } from "./";
import AppointmentTypeModal from "./AppointmentTypeModal";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

// import TREE from "../../images/tree.png";

// const PriceDesignForCampaign = () => (
//   <div className="gap-2 d-flex justify-content-center">
//     {[0, 1, 2].map((i) => {
//       return (
//         <img key={i} src={TREE} style={{ width: "16px", height: "16px", objectFit: "contain" }} />
//       );
//     })}
//   </div>
// );

const FlipCard = (props) => {
  const {
    type = "offers",
    offer = {},
    setLoading = () => null,
    availOfferButton: AvailOfferButton,
    openNonCampaignDetailsModal,
    handleTermsModalVisibility
  } = props;

  const isAddonOrUpsell = type === "appointment" || type === "upsell";
  const quotationService = offer.isQuotationService;

  const parentContainerClassNames = {
    general: `flip-card ${quotationService ? "flip-card-quote" : ""} `,
    offers: "col-md-6 col-lg-6 col-xl-3",
    appointment: "col-md-6 col-lg-6 col-xl-3",
    upsell: "col-md-6 col-lg-6 col-xl-4",
    packages: "col-12 col-md-6 col-lg-4 col-xl-4 sm-size",
    buildBundle: "col-md-12 col-lg-12 col-xl-12 sm-size yellow-theme"
  };

  const { t } = useTranslation();
  const lang = currentLanguage();
  const { toUrlWithData, localeRoutes, toRequestAQuote } = useAppNavigation();
  const [showModal, setShowModal] = useState(false);
  const [showAppointmentTypeModal, setShowAppointmentTypeModal] = useState(false);

  const user = useSelector((state) => state.user.details);

  const goToBooking = async () => {
    const showModalInitially = user?.id && !user.notifications?.isOfferTermsAcknowledged;
    if (showModalInitially && handleTermsModalVisibility) {
      NotificationHelper.info(t("offer.tncAlert"));
      handleTermsModalVisibility();
      return;
    }

    if (quotationService) {
      toRequestAQuote(offer.slugUrl);
    } else if (offer?.isCAD) {
      setShowAppointmentTypeModal(true);
    } else {
      toUrlWithData(localeRoutes.bringIt[lang], {
        service: { id: offer.id },
        offer: true
      });
    }
    setShowModal(false);
  };

  const handleModal = () => {
    if (!offer.isCampaignActive) return openNonCampaignDetailsModal(offer, "offers");

    setLoading(true);
    setShowModal(true);
  };

  return (
    <>
      {!offer ? null : (
        <>
          <div className={parentContainerClassNames.general + parentContainerClassNames[type]}>
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div
                  className="image"
                  style={{
                    backgroundImage: `url(${GET_MEDIA_URL + offer["image_" + lang]})`
                  }}>
                  <h3>{offer.name["value_" + lang]}</h3>
                  {(offer.isCampaignActive || offer.isPackage) && !isAddonOrUpsell && (
                    <>
                      <div className="expiry-date">
                        <span>
                          {t("services.validity")}:{" "}
                          {getFormatedDate(
                            offer.isCampaignActive ? offer.campaignEndDate : offer.endDate,
                            "ll"
                          )}
                        </span>
                      </div>
                      {offer.ribbonText?.value_en && (
                        <div className="ribbon-wrapper">
                          <div className="ribbon-tag">{offer.ribbonText["value_" + lang]}</div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                {offer.isCampaignActive ? (
                  <div className="details">
                    {/* {!isAddonOrUpsell && <PriceDesignForCampaign />} */}
                    <span>
                      <RiyalIcon />
                      {formatAmount(offer.campaignPrice)}
                      <br />
                      <del>{formatAmount(offer.price)}</del>
                    </span>
                    {/* {!isAddonOrUpsell && <PriceDesignForCampaign />} */}
                  </div>
                ) : (
                  offer.price > 0 && (
                    <div className="details">
                      <span>
                        <RiyalIcon />
                        {formatAmount(offer.price)}
                      </span>
                    </div>
                  )
                )}
              </div>
              <div className="flip-card-back">
                <span className="name">{offer.name["value_" + lang]}</span>
                <p
                  className="shortDesc"
                  dangerouslySetInnerHTML={{
                    __html: offer.detail?.["value_" + lang] || offer.description?.["value_" + lang]
                  }}
                />
                {(offer.isCampaignActive) && (
                  <Button type="blue-text" customize="m-0 mt-3" action={handleModal}>
                    {t("services.seeMore")}
                  </Button>
                )}
              </div>
            </div>
            <div className="details">
              {AvailOfferButton || (
                <Button className="btn" action={goToBooking}>
                  {quotationService
                    ? t("quotations.getQuoteBtn")
                    : offer.isPackage
                      ? t("services.book")
                      : t("offer.buyAndBook")}
                </Button>
              )}
            </div>
          </div>

          {offer.isCampaignActive && (
            <CampaignViewModal
              {...{
                show: showModal,
                onCancel: () => setShowModal(false),
                offer,
                setLoading,
                goToBooking,
                AvailOfferButton
              }}
            />
          )}

          <AppointmentTypeModal
            {...{
              show: showAppointmentTypeModal,
              onCancel: () => setShowAppointmentTypeModal(false),
              offerId: offer?.id,
            }}
          />
        </>
      )}
    </>
  );
};

const CampaignViewModal = ({
  show,
  onCancel,
  offer,
  setLoading,
  goToBooking,
  AvailOfferButton
}) => {
  const { t } = useTranslation();
  const lang = currentLanguage();

  const handleImageLoad = () => setLoading(false);

  return (
    <Modal size="xl" show={show} onHide={onCancel} centered>
      <Modal.Body className="addon-desc-modal">
        <div className="close-icon">
          <Icon iconName="xmark" onClick={onCancel} />
        </div>

        <div className="content">
          <img
            src={
              GET_MEDIA_URL +
              (offer?.["campaignImage_" + lang] ||
                offer?.["campaignImage" + convertToSentenceCase(lang)])
            }
            onLoad={handleImageLoad}
          />
          <h2>{offer?.name?.["value_" + lang] || ""}</h2>
          <div className="addon-desc">
            <h5>{t("offersDetail.title")}</h5>
            <p
              className="shortDesc"
              dangerouslySetInnerHTML={{
                __html: offer.campaignTermsAndConditions?.["value_" + lang]
              }}
            />
          </div>
          <div className="button-and-expiry-wrap cart-btn w-100">
            <div>
              {AvailOfferButton || (
                <Button type="big-roundedRight" action={goToBooking}>
                  {t("offersDetail.bookAppointment")}
                </Button>
              )}
            </div>
            <div className="campaign-metadata">
              <div>
                <div>
                  <span>{t("offersDetail.oldPrice")}</span>
                  <RiyalIcon />
                  <del className="fw-bold">{offer?.price}</del>
                </div>
                <div>
                  <span>{t("offersDetail.price")}</span>
                  <span className="fw-bold">
                    <RiyalIcon />
                    {offer?.campaignPrice}
                  </span>
                </div>
              </div>
              <div>
                <span>{t("offersDetail.campaignExpiryDate")}:</span>
                <span className="fw-bold">
                  {getFormatedDate(offer?.campaignEndDate, "MMMM DD, YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(FlipCard);
